import { c as _c } from "react/compiler-runtime";
import { removeDomain } from 'modules/profile/custom-domains-settings/api/custom-domain-api';
import { CustomDomainsSettingsInterface } from 'modules/profile/custom-domains-settings/types/custom-domains-settings-interface';
import React from 'react';
import ConfirmationModal from 'shared/components/confirmation-modal';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
interface RemoveDomainModalInterface {
  opened: boolean;
  onClose: () => void;
  domain: CustomDomainsSettingsInterface;
  removeDomainWithUpdate: () => Promise<void>;
}
const RemoveDomainModal = t0 => {
  const $ = _c(14);
  const {
    opened,
    onClose,
    domain,
    removeDomainWithUpdate
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] !== domain.id || $[1] !== removeDomainWithUpdate) {
    t1 = async () => {
      await removeDomain(domain.id);
      await removeDomainWithUpdate();
    };
    $[0] = domain.id;
    $[1] = removeDomainWithUpdate;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const onRemove = t1;
  let t2;
  if ($[3] !== domain.domainName || $[4] !== t) {
    t2 = t("dashboard.settings.custom_domains.remove_confirmation", {
      user_domain: domain.domainName
    });
    $[3] = domain.domainName;
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t) {
    t3 = t("confirmation_modal.default_title");
    $[6] = t;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== onClose || $[9] !== onRemove || $[10] !== opened || $[11] !== t2 || $[12] !== t3) {
    t4 = <ConfirmationModal opened={opened} onClose={onClose} onConfirm={onRemove} confirmationText={t2} title={t3} />;
    $[8] = onClose;
    $[9] = onRemove;
    $[10] = opened;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
};
export default RemoveDomainModal;